/**
 * Marka sabitleri — sunucu ve istemci ortak kullanır; bağımlılığı yok.
 * Asıl çözümleme: sunucuda `@/lib/brand`, istemcide `@/lib/brand-context`.
 */

/** Metinde markanın yeri. DB metinleri de aynı belirteci kullanır. */
export const BRAND_TOKEN = "{{SITE_NAME}}";

/** Nötr yedek. Başka hiçbir markanın adı yedek olarak yazılmaz. */
export const NEUTRAL_BRAND_NAME = "Hal Fiyatları";

/** env'den gelen ad; panel verisi yokken kullanılır. */
export const ENV_BRAND_NAME = (process.env.NEXT_PUBLIC_SITE_NAME ?? "").trim() || NEUTRAL_BRAND_NAME;

/** `{{SITE_NAME}}` belirtecini marka adıyla değiştirir. Deterministik, saf. */
export function brandText(text: string, brand: { name: string }): string {
  return text.split(BRAND_TOKEN).join(brand.name);
}
